import React from 'react';
import { Activity } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-[25px] pb-[30px] px-[15px]" data-id="element-156">
      <div className="max-w-[650px] mx-auto" data-id="element-157">
        <p className="text-[#EF4444] font-[800] uppercase text-[13px] mb-[10px] tracking-[0px]" data-id="element-158">
          ⚠️ If your knee feels "untrustworthy"… read this. ⚠️
        </p>

        <h1 className="text-[23px] leading-[1.2] mb-[15px] font-[800] text-[#111827] font-['Montserrat']" data-id="element-159">
          <strong data-id="element-160">The Knee Geometry Method</strong>
          <br data-id="element-161" />
          <span className="relative inline-block" data-id="element-162">
            <span className="relative z-10 text-[#DC2626] font-[900] text-[26px]" style={{
            background: 'linear-gradient(180deg, transparent 50%, rgba(252,165,165,0.4) 50%)',
            padding: '0 6px',
            animation: 'highlightPulse 2s ease-in-out infinite'
          }} data-id="element-163">
              15 Days
            </span>
          </span>{' '}
          to walk without fear—at home, low impact—
          <span className="bg-gradient-to-r from-[#FCA5A5] to-transparent px-[5px] py-0" data-id="element-164">
            without pushing through pain
          </span>
          .
        </h1>

        <p className="text-[16px] leading-[1.5] max-w-[600px] mx-auto text-[#6B7280] mb-[20px]" data-id="element-165">
          A step-by-step system that rebuilds the angles, stability, and
          confidence your knee needs to feel safe again.
        </p>

        <div className="mb-[20px] rounded-[12px] overflow-hidden shadow-[0_0_25px_rgba(220,38,38,0.6),0_8px_25px_rgba(0,0,0,0.2)] bg-gradient-to-br from-[#FEF2F2] to-[#FEE2E2] p-0 flex items-center justify-center min-h-[300px]" data-id="element-166">
          <img src="https://cdn.magicpatterns.com/uploads/dhFEgYBjJoWDrrEjUjNWsZ/mock_up_english.png" alt="The Knee Geometry Method Mockup" className="w-full h-auto object-cover" data-id="element-167" />
        </div>

        <a className="block w-full max-w-[380px] mx-auto bg-gradient-to-br from-[#DC2626] to-[#EF4444] text-white border-none p-[16px] text-[18px] font-[700] rounded-[50px] cursor-pointer shadow-[0_8px_20px_rgba(220,38,38,0.3)] text-center no-underline uppercase font-['Montserrat'] animate-pulse-custom hover:transform hover:-translate-y-[3px] hover:scale-[1.02] hover:shadow-[0_8px_20px_rgba(220,38,38,0.5)] transition-all duration-400" href="#get-the-method" data-id="element-168">
          👉 I WANT THE KNEE GEOMETRY METHOD
        </a>

        <div className="text-[11px] mt-[10px] text-[#6B7280] text-center" data-id="element-169">
          ⚡ Instant download · Limited time offer
        </div>
      </div>
    </section>;
}